import { VisibilitaRequestDTO } from "./visibilita-requestDTO";

export class ModificaVisibilitaRequestDTO {
    aggiunte: VisibilitaRequestDTO[];
    rimozioni: VisibilitaRequestDTO[];
}
